<template>
  <div class="manage-banner">
    <el-row type="flex" align="middle" class="page-title">
      <i class="el-icon-menu mr-s" />
      <h3>{{ $route.params.id ? "Cập nhật banner" : "Tạo mới banner" }}</h3>
    </el-row>
    <el-row class="content">
      <el-col :span="24" :lg="16">
        <el-card>
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="Tiêu đề" prop="title">
              <el-input
                v-model="form.title"
                :disabled="callingAPI"
                placeholder="Tiêu đề banner"
              />
            </el-form-item>
            <el-form-item label="Mô tả" prop="description">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.description"
                :disabled="callingAPI"
                placeholder="Mô tả"
              />
            </el-form-item>
            <el-form-item label="Từ khoá" prop="keyword">
              <el-input
                v-model="form.keyword"
                :disabled="callingAPI"
                placeholder="Từ khoá"
              />
            </el-form-item>
            <el-form-item label="Tải lên ảnh đại diện bài viết">
              <el-row type="flex" class="w-full">
                <el-upload
                  ref="uploadAvatar"
                  class="upload upload-avatar"
                  drag
                  accept=".jpeg,.png,.jpg,.gif"
                  action="#"
                  :auto-upload="false"
                  :on-change="changeAvatar"
                  :show-file-list="false"
                >
                  <div class="w-full">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      Kéo thả ảnh hoặc <em>click để upload ảnh</em>
                    </div>
                  </div>
                </el-upload>
                <div
                  v-if="form.image && !isUploadedAvatar"
                  class="preview-avatar ml-xl"
                >
                  <img :src="form.image" alt="" />
                </div>
                <el-row
                  v-show="isUploadedAvatar"
                  class="preview-avatar ml-xl"
                  type="flex"
                  justify="center"
                >
                  <img id="avatar-img-url" />
                </el-row>
              </el-row>
            </el-form-item>
          </el-form>
          <el-row type="flex" justify="end" class="mt-xl">
            <el-button
              class="mt-xl"
              type="primary"
              :loading="callingAPI"
              @click="handleManage"
            >
              {{ $route.params.id ? "Cập nhật" : "Tạo mới" }}
            </el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { createBanner, fetchBannerById, updateBanner } from "@/services/banner";
import { replaceUrlResourceBlog } from "@/utils/common";
export default {
  name: "CreateUpdateBanner",
  data() {
    return {
      form: {
        title: "",
        description: "",
        keyword: "",
        image: null,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Tiêu đề không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        keyword: [
          {
            required: true,
            message: "Keyword không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      },

      callingAPI: false,

      fileAvatar: null,
      isUploadedAvatar: false,
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    changeAvatar(file) {
      var reader = new FileReader();
      reader.onload = function () {
        var output = document.getElementById("avatar-img-url");
        output.src = reader.result;
      };
      this.isUploadedAvatar = true;
      reader.readAsDataURL(file.raw);
      this.fileAvatar = file.raw;
    },

    async loadData() {
      try {
        this.callingAPI = true;

        const response = await fetchBannerById(this.$route.params.id);
        this.form.title = response.data.title;
        this.form.description = response.data.description;
        this.form.keyword = response.data.keyword;
        this.form.image = replaceUrlResourceBlog(response.data.image);
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleManage() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            let formData = new FormData();
            formData.append("title", this.form.title);
            formData.append("description", this.form.description);
            formData.append("keyword", this.form.keyword);
            if (this.$route.params.id) {
              formData.append("_method", "PUT");
              if (this.fileAvatar) {
                formData.append("image", this.fileAvatar);
              }
              await updateBanner(this.$route.params.id, formData);
            } else {
              if (!this.fileAvatar) {
                this.$message.error("Vui lòng thêm ảnh cho Banner");
                return;
              }
              formData.append("image", this.fileAvatar);
              await createBanner(formData);
            }
            this.$router.push({ name: "ManageBanner" });
            this.callingAPI = false;
          } catch (error) {
            this.callingAPI = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.upload {
  width: 100%;
  height: 225px;

  &.upload-avatar {
    width: 300px;
    height: 225px;
  }

  .el-upload {
    width: 100%;
    height: 100%;

    .el-upload-dragger {
      width: 100%;
      height: 100%;
    }
  }
}

.preview-avatar {
  flex-direction: column;
  align-items: center;

  img {
    max-width: 300px;
    object-fit: cover;
  }
}

.el-upload__tip {
  line-height: 1;
}

.preview-file {
  overflow: hidden;

  img {
    max-width: 100%;
    object-fit: cover;
  }
}
</style>
